import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PrivateRouteProps {
  children: ReactNode;
  requireWriter?: boolean;
  requireAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireWriter = false, requireAdmin = false }) => {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p role="status" className="text-sm text-gray-500">Loading your account…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !profile?.is_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Admin Access Required</h2>
          <p className="text-gray-600 mb-6">You need admin permissions to access this page.</p>
        </div>
      </div>
    );
  }

  if (requireWriter && (!profile?.is_writer && !profile?.is_admin)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Writer Access Required</h2>
          <p className="text-gray-600 mb-6">You need writer permissions to access this page.</p>
          <a href="/profile" className="text-indigo-600 hover:text-indigo-800">
            Update your profile to become a writer
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;